// ─── THEME ────────────────────────────────────────────────────────────────────
// All values are CSS Custom Property references.
// Light/dark variable definitions live in GlobalStyles.jsx.
const T = {
  // Backgrounds
  bg:            "var(--vg-bg)",
  sidebar:       "var(--vg-sidebar)",
  card:          "var(--vg-card)",
  hover:         "var(--vg-hover)",
  cardHover:     "var(--vg-card-hover)",
  // Primary
  primary:       "var(--vg-primary)",
  primaryHover:  "var(--vg-primary-hover)",
  primaryLight:  "var(--vg-primary-light)",
  primaryBorder: "var(--vg-primary-border)",
  // Text
  text:          "var(--vg-text)",
  textMid:       "var(--vg-text-mid)",
  textMuted:     "var(--vg-text-muted)",
  textLight:     "var(--vg-text-light)",
  // Borders
  border:        "var(--vg-border)",
  borderLight:   "var(--vg-border-light)",
  // Shadows
  shadow:        "var(--vg-shadow)",
  shadowMd:      "var(--vg-shadow-md)",
  shadowLg:      "var(--vg-shadow-lg)",
  // Danger
  danger:        "var(--vg-danger)",
  dangerLight:   "var(--vg-danger-light)",
  dangerBorder:  "var(--vg-danger-border)",
  dangerText:    "var(--vg-danger-text)",
  // Success
  success:       "var(--vg-success)",
  successLight:  "var(--vg-success-light)",
  successBorder: "var(--vg-success-border)",
  successText:   "var(--vg-success-text)",
  // Warning
  warning:       "var(--vg-warning)",
  warningLight:  "var(--vg-warning-light)",
  // Radius (static — same in both modes)
  radius:        "10px",
  radiusMd:      "12px",
  radiusLg:      "16px",
};

export default T;
